<template>
  <main class="page">
    <AppBack></AppBack>
    <section class="section page__header">
      <h1 class="title">{{ isCreate ? 'Создать объект' : 'Редактировать объект' }}</h1>
    </section>

    <div class="form__bg">
      <section class="section">
        <div class="form__inputs form__inputs_col-1">
          <AppInput title="Наименование"
                    required
                    :value="object.name"
                    :valid="validation.name"
                    @value-changed="setName"
                    @got-focus="clearValidation('name')"
          />
        </div>
        <div class="form__inputs">
          <AppInput title="Шифр"
                    required
                    :value="object.code"
                    :valid="validation.code"
                    @value-changed="setCode"
                    @got-focus="clearValidation('code')"
          />
          <AppInput title="ФИО Мастера"
                    :value="object.master"
                    @value-changed="setMaster"
          />
        </div>
        <div class="form__inputs form__inputs_col-1">
            <AppTextarea title="Примечание"
                         :value="object.comment"
                         @value-changed="setComment"
                         minWidth="832px"
            />
          </div>
      </section>
      <section class="section" style="margin-top: 32px">
      <div class="page__buttons">
        <div class="page__item">
          <AppButton
            :title="isCreate ? 'Создать' : 'Сохранить'"
            type="main"
            @click.stop.native="saveObjectInfo"
          />
        </div>
        <div class="page__item">
          <AppButton
            title="Отмена"
            type="alt"
            @click.stop.native="leavePage"
          />
        </div>
      </div>
    </section>
    </div>

    <ThePagePreloader v-if="isCreate ? false : isLoading"/>

  </main>
</template>

<script>
import AppButton from '@/components/page/button/AppButton'
import ThePagePreloader from '@/components/page/ThePagePreloader'
import AppInput from '@/components/page/input/AppInput'
import AppTextarea from '@/components/page/input/AppTextarea'
import AppBack from '../../components/page/AppBack'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'LogisticObjectUpdate',
  components: {
    AppTextarea,
    AppInput,
    AppButton,
    ThePagePreloader,
    AppBack
  },
  data () {
    return {
      isCreate: false
    }
  },
  computed: {
    ...mapGetters('logistic/objectUpdate', {
      object: 'getObjectItem',
      validation: 'getObjectItemValidation',
      isLoading: 'getObjectItemIsLoading'
    })
  },
  methods: {
    ...mapMutations('logistic/objectUpdate', {
      setName: 'SET_OBJECT_ITEM_NAME',
      setCode: 'SET_OBJECT_ITEM_CODE',
      setMaster: 'SET_OBJECT_ITEM_MASTER',
      setComment: 'SET_OBJECT_ITEM_COMMENT',
      clearValidation: 'CLEAR_OBJECT_ITEM_VALIDATION',
      setIsLoading: 'SET_OBJECT_ITEM_IS_LOADING',
      setInitialState: 'SET_OBJECT_INITIAL_STATE'
    }),

    ...mapActions('logistic/objectUpdate', {
      getObjectItem: 'getObjectItem',
      saveObjectInfo: 'saveObjectItem'
    }),

    leavePage () {
      this.$router.push({ name: 'LogisticObjectList' })
    }
  },

  mounted () {
    const id = this.$router.history.current.params.id

    this.setInitialState()

    if (id === 'create') {
      this.isCreate = true
    } else {
      this.getObjectItem(id)
      this.isCreate = false
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
